"use strict";

PF.Field.TreeSelect = class TreeSelect extends PF.Field
	{
	static get options()
		{
		return {
			html: PF.Field.TreeSelect.templates,
			popupConfig: {
				title: 'Выберите значение'
			},

			label: "Выберите значение",
			model: new PF.Model({}),
			key: 'value',
			searchLabel: 'Поиск',

			showInfo: true,
			helper: '',

			includeRoot: false,
			typeKey: '#table',
			types: {
				root: {
					id: 'root',
					childs: []
				},
			},
			defaultItemClass: PF.Field.TreeSelect.Item,
			errors: {}
		};
		}

	static get templates()
		{
		return {
			//language=HTML
			wrapper: `
				<div class="pf-select-wrapper">
					<div class="pf-select" pf="select">
						<div class="pf-select-label" pf="label"></div>
						<div class="pf-selected" pf="selected">&nbsp;</div>

					</div>
					<div class="underline">
						<hr class="normal"/>
						<hr class="focus"/>
					</div>
					<div class="info" pf="info">&nbsp;</div>
				</div>
			`,
			//language=HTML
			popupContent: `
				<div class="pf-tree-select-popup-content">
					<div class="pf-list-crud-header" pf="header">

						<div class="title-row" pf="titleRow">
							<div class="title" pf="title"></div>
							<div class="search-box" pf="searchBox">
								<input type="text" pf="search"/>
							</div>
						</div>
						<div class="actions">
							<a class="link" style="display: none" class="search-toggle" pf="searchToggle"><i class="material-icons">search</i></a>
						</div>
					</div>
					<div class="pf-tree" pf="tree"></div>
				</div>
			`,
		};
		}


	init()
		{
		this.dom.loads(this.html);
		this.dom.element.append(this.dom.wrapper);

		this.popup = new PF.F7Popup({
			dom: {content: this.dom.popupContent},
			...this.popupConfig
		});
		this.dom.select.on('click', () => this.popup.open());

		this.hash = PF.H.hash(this.types);
		this.states = JSON.parse(window.localStorage.getItem(this.hash)) || {};
		this.onFinish('changeOpenStates', () => {
			this.states = this.root.collectStates(this.states);
			window.localStorage.setItem(this.hash, JSON.stringify(this.states));
		}, 100);

		this.root = PF.H.create(this.types.root.itemClass || this.defaultItemClass, {list: null, tree: this, parent: null, ...this.types.root, model: this.types.root.model},);
		this.root.render();
		this.bindDom({tree: 'content'}, 'includeRoot', (i) => {
			return i === true ? this.root.dom.item : this.root.dom.childsList;
		});

		this.nullItem = this.root.childsList.create(new PF.Model({raw: null}));
		this.root.childsList.unshift(this.nullItem);
		this.root.childsList.on('add', () => {
			this.root.childsList.dom.ul.prepend(this.nullItem.dom.item);
		});

		if (this.model.get(this.key, null, null) === null)
			{
			this.model.setData(this.key, this.nullItem.model, true);
			}

		this.on('model.change:' + this.key, () => {
			this.selected = this.findItemByModel(this.model.get(this.key));
			this.validate(true);
			this.popup.close();
		}, true);
		this.on('childs-changed', () => {
			this.selected = this.findItemByModel(this.model.get(this.key));
			this.validate(true);
		});
		this.on('change:selected', () => {
			this.model.setData(this.key, this.selected.model);
			if (this.idKey !== undefined)
				{
				this.model.setData(this.idKey, this.selected.model.get(this.dictIdKey));
				}
		});

		this.bindDom({wrapper: 'class:error'}, 'error', (e) => e !== '');
		this.bindDom({wrapper: 'class:focus'}, 'popup.opened');
		this.bindDom({info: 'html'}, ['helper', 'error'], (h, e) => e !== '' ? e : h !== '' ? h : '&nbsp;');
		this.bindDom({info: 'show'}, 'showInfo');
		this.bindDom({label: 'html'}, 'label');
		this.bindDom({select: 'class:active'}, 'model.' + this.key, (v) => v !== null && v.isNull() !== true);
		this.bindDom({selected: 'content'}, 'selected', (s) => s.dom.itemInnerForSelect);

		this.initSearch();
		}

	initSearch()
		{
		this.dom.searchToggle.show();
		this.searchString = new PF.Field.String({
			dom: {
				element: this.dom.search
			},
			key: 'value',
			model: new PF.Model({raw: {value: ''}}),
			label: this.searchLabel,
			showInfo: false
		});

		this.searchShow = true;
		this.dom.searchToggle.on('click', () => this.searchShow = !this.searchShow);
		this.bindDom({searchToggle: 'class:active', titleRow: 'class:search-show'}, 'searchShow');

		this.onValue('searchShow', true, () => this.searchString.setFocus());
		this.onValue('searchShow', false, () => this.searchString.model.value = '');

		this.onChange('searchString.model.value', () => {
			this.searchValue = this.searchString.model.get('value');
			this.root.searchValue = this.searchValue;
		});
		}

	findItemByModel(model)
		{
		return this.root.childsList.findItemByModel(model);
		}

	validate(silent, error = undefined)
		{
		if (this.required === true)
			{
			if (this.model.get(this.key, null, null) === null)
				{
				return super.validate(silent, this.errors.required);
				}
			}
		return super.validate(silent, error);
		}

	};


PF.Field.TreeSelect.Item = class Item extends PF.List.Item
	{
	static get options()
		{
		return {
			html: PF.Field.TreeSelect.Item.templates,
			selectable: false,
			childListConfig: {search: '@{name}', modelsConfig: {loadOnInit: false, filterDebounceMethod: 'onFinish'}},
			simpleName: '@{model.name}',
			childsKey: undefined,

		};
		}

	get renderer()
		{
		//language=HTML
		return `
			<li class="accordion-item pt-tree-select-node" pf="item">
				<div class="pf-tree-body" pf="body">

				</div>
				<div class="accordion-item-content">
					<div class="list" pf="childsList">
						<div pf="childs">
						</div>
					</div>
				</div>
			</li>
		`;
		}

	static get templates()
		{
		return {
			body: [
				{
					selectable: true,
					expandable: true,
					//language=HTML
					template: `
						<label class="item-radio item-content">
							<input type="radio" pf="input"/>
							<i class="icon icon-radio"></i>
						</label>
						<a href="#" class="item-content item-link pf-accordion-link" pf="openLink">
							<div class="itemInnerContainer" pf="itemInnerContainer"></div>
						</a>
					`,
				},
				{
					selectable: true,
					expandable: false,
					//language=HTML
					template: `
						<label class="item-radio item-content">
							<input type="radio" pf="input"/>
							<i class="icon icon-radio"></i>
							<div class="itemInnerContainer" pf="itemInnerContainer"></div>
						</label>
					`,
				},
				{
					selectable: false,
					expandable: true,
					//language=HTML
					template: `
						<a href="#" class="item-content item-link pf-accordion-link" pf="openLink">
							<div class="itemInnerContainer" pf="itemInnerContainer"></div>
						</a>
					`,
				},
				{
					selectable: false,
					expandable: false,
					//language=HTML
					template: `
						<div class="item-content">
							<div class="itemInnerContainer" pf="itemInnerContainer"></div>
						</div>
					`,
				}
			]
		};
		}

	get bodyTemplate()
		{
		for (let i = 0; i < this.html.body.length; i++)
			{
			if (this.html.body[i].selectable === this.selectable && this.html.body[i].expandable === this.expandable)
				{
				return this.html.body[i].template;
				}
			}
		}

	get itemInner()
		{
		//language=HTML
		return `
			<div class="item-inner">
				<div class="item-title">
					@{simpleName}
				</div>
			</div>`;
		}

	get nullItemInner()
		{
		//language=HTML
		return `
			<div class="item-inner">
				<div class="item-title">
					Нет данных
				</div>
			</div>`;
		}

	init()
		{
		this.dom.loads(this.html);
		this.displayLength = 0;
		this.selectable = this.model.isNull() === true ? true : this.selectable;
		}

	render()
		{
		this.dom.load(this.renderer);
		this.onRender({});
		}

	onRender(event)
		{
		super.onRender(event);

		this.childListConfig.modelsConfig.parent = this.model;
		this.childsList = new PF.Field.TreeSelect.List({
			dom: {element: this.dom.childs},
			parent: this,
			tree: this.tree,
			models: this.model.get(this.childsKey),
			...this.childListConfig
		});
		this.childsList.models.loadCount();
		this.childsList.models.on('load-part', () => this.tree.trigger('childs-changed'));
		this.childsList.models.filter.and(`(${this.childListConfig.search} ~ @{list.parent.searchValue})`, 'l');

		this.calc('searchValue', ['model.options.filterShow', 'tree.searchValue'], (s, v) => {
			if (v === undefined)
				{
				return '';
				}
			this.childsList.models.loadPart();
			if (s === false)
				{
				this.openState = true;
				}
			else
				{
				this.openState = false;
				}
			return s === false ? v : '';
		});
		this.calc('displayState', ['model.options.filterShow', 'displayLength'], (f, l) => {
			return f || l > 0;
		});
		if (this.parent !== null)
			{
			this.onValue('displayState', true, () => this.parent.displayLength++);
			this.onValue('displayState', false, () => this.parent.displayLength--);
			}

		// this.calc('expandable', ['displayLength', 'childsList.models.initStatus'], (c, i) => c > 0 || i === 'notInit');
		this.calc('expandable', ['childsList.models.dataStatus', 'displayLength', 'childsList.models.count'], (s, d, c) => s === 'notLoaded' ? c > 0 : d > 0);
		// this.calc('expandable', [
		// 	'childsList.models.dataStatus', 'childsList.models.filterLength', 'childsList.models.count'
		// ], (s, f, c) => s === 'notLoaded' ? c > 0 : f > 0);

		this.onChange('selectable', () => this.setupBody());
		this.onChange('expandable', () => this.setupBody());
		this.setupBody();
		// this.childsList.models.filterLocal();

		this.onChange('openState', () => {
			console.log('openState change: ', this.model.get('name') || this.model.get('address') || this.model.get('number'), this.openState);
		});
		}

	bindDomFilter()
		{
		this.bindDom({item: 'show'}, 'displayState');
		}

	setupBody()
		{
		this.dom.body.empty();
		this.dom.load(this.bodyTemplate, 'bodyContent');
		this.dom.body.append(this.dom.bodyContent);
		this.dom.load(this.model.isNull() ? this.nullItemInner : this.itemInner, 'itemInner');
		this.dom.load(this.model.isNull() ? '<span>&nbsp;</span>' : this.itemInner, 'itemInnerForSelect');
		this.dom.itemInnerContainer.append(this.dom.itemInner);

		this.dom.body.bindObject(this);
		this.dom.itemInnerForSelect.bindObject(this);

		if (this.expandable === true)
			{
			this.setupExpandableBody();
			}
		if (this.selectable === true)
			{
			this.setupSelectableBody();
			}
		}

	setupExpandableBody()
		{
		this.dom.openLink.on('click', (event) => {
			event.stopPropagation();
			this.openState = !this.openState;
		});
		this.openState = PF.H.get(this.tree.states, this.model.get('id'), false, false);
		this.bindDom({item: 'class:accordion-item-opened'}, 'openState');
		this.onValue('openState', true, () => {
			if (this.childsList.models.dataStatus !== 'allLoaded')
				{
				this.childsList.models.loadPart();
				}
		});
		this.onValue('openState', false, () => this.goDownState('openState', false));
		this.onChange('openState', () => this.tree.trigger('changeOpenStates'));
		}

	setupSelectableBody()
		{
		this.dom.input.bindAll();
		this.dom.input.attributes.name = this.tree.name;

		this.connect('dom.input.value', 'selectState');

		this.onValue('selectState', true, () => {
			if (this.tree.selected !== this)
				{
				this.tree.selected.selectState = false;
				}
			this.tree.selected = this;
		});
		}

	goDownState(state, value, own = true)
		{
		if (own)
			{
			PF.H.set(this, state, value);
			}
		for (let i = 0; i < this.childsList.length; i++)
			{
			this.childsList[i].goDownState(state, value);
			}
		}

	collectStates(states = {})
		{
		states[this.model.get('id', 'undefinedIdentifier', 'undefinedIdentifier')] = this.openState;
		for (let i = 0; i < this.childsList.length; i++)
			{
			this.childsList[i].collectStates(states);
			}
		return states;
		}

	destroy()
		{
		super.destroy();
		this.childsList.destroy();
		this.childsList = undefined;
		if (this.parent !== null && this.displayState === true)
			{
			this.parent.displayLength--;
			}
		}
	};

PF.Field.TreeSelect.List = class TreeSelectList extends PF.List
	{
	static get options()
		{
		return {
			searchable: false,
			enableDummy: false,
			enableHeader: false,
			html: {
				//language=HTML
				wrapper: `
					<div class="pf-list-wrapper" pf="wrapper">
						<ul pf="ul">

						</ul>
						<div class="preloader-container" pf="preloaderContainer">
							<div class="preloader" pf="preloader"></div>
						</div>
						<div class="pf-list-dummy" pf="dummy"><p pf="dummyText"></p>
						</div>
					</div>
				`
			}
		};
		}

	init()
		{
		super.init();
		this.bindDom({wrapper: 'class:pf-root-wrapper'}, 'parent.parent', (p) => p === null);
		}

	create(model)
		{
		let config = this.tree.types[model.get(this.tree.typeKey)];
		let itemClass = PF.H.get(config, 'itemClass', this.tree.defaultItemClass, this.tree.defaultItemClass);
		return PF.H.create(itemClass, {list: this, model: model, tree: this.tree, parent: this.parent, ...config});
		}

	findItemByModel(model)
		{
		for (let i = 0; i < this.length; i++)
			{
			if (PF.H.compareByPks(model, this[i].model))
				{
				return this[i];
				}
			let item = this[i].childsList.findItemByModel(model);
			if (item !== this.tree.nullItem)
				{
				return item;
				}
			}
		return this.tree.nullItem;
		}
	};